export const formatCurrency = (price: string, currency: string): string => {
  const numericPrice = parseFloat(price)
  switch (currency) {
    case 'USD':
      return `$${numericPrice.toFixed(2)} USD`
    case 'GBP':
      return `£${numericPrice.toFixed(2)} GBP`
    case 'AUD':
      return `A$${numericPrice.toFixed(2)} AUD`
    case 'CAD':
      return `C$${numericPrice.toFixed(2)} CAD`
    case 'JPY':
      return `¥${numericPrice} JPY`
    case 'KRW':
      return `₩${numericPrice} KRW`
    default:
      return `${numericPrice.toFixed(2)} ${currency}`
  }
}
